const toMixedUse = project => {
  return {
    ...project,
    building_type_name_en: 'Mixed-use',
    building_type_name_th: 'อาคารแบบผสม',
  };
};

const convertProject = project => {
  return project.is_mixed_use ? toMixedUse(project) : project
};

/** True if project was created via reference follow-up (server sets parent_project_id). */
const isFollowupReferenceProject = project => {
  if (!project) return false;
  const pid = project.parent_project_id != null
    ? project.parent_project_id
    : project.parent_project && project.parent_project.id;
  return pid != null && pid !== '';
};

export {
  convertProject,
  isFollowupReferenceProject,
};



// WEBPACK FOOTER //
// ./src/utils/converter.js